import { call, put, takeLatest } from 'redux-saga/effects';
import { VERIFY_SLACK_START } from './constants';
import { verifySlackSuccess, verifySlackError } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import { SLACK_VERIFY } from 'common/strings';
import localStorageTemplates from 'common/local-storage-templates';
import { readToken } from 'utils/readToken';

export function* verifySlack({ payload }) {
  const token = readToken();
  try {
    const response = yield call(request, {
      method: 'post',
      endpoint: 'app/integration/slack',
      config: {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });

    triggerNotification({
      title: SLACK_VERIFY.ALERTS.INTEGRATE_SLACK_SUCCESS,
      type: NOTIFICATION.TYPE.SUCCESS,
    });
    yield put(verifySlackSuccess());
  } catch (error) {
    const errorMessage = convertErrorMsg(error);

    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifySlackError(errorMessage));
  }
}

export default function* slackVerify() {
  yield takeLatest(VERIFY_SLACK_START, verifySlack);
}
